import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import { Faq, FaqQuery } from '../models/Faq'
import { ItemList } from '../../../common/models/ItemList'
import { Query } from '../../../common/api/Query'
import { FaqDTO } from '../models/FaqDTO'
import { IFaqApi } from '../api/FaqApi'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IFaqService extends IInit {
  getByID(id: string): Observable<Faq | undefined>

  getFilteredList(q: Query<FaqQuery>): Observable<ItemList<Faq>>

  add(e: Faq): Observable<Faq | undefined>

  update(e: FaqDTO): Observable<Faq | undefined>

  delete(id: string): Observable<boolean>
}

export class FaqService implements IFaqService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IFaqApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IFaqApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: FaqDTO): Observable<Faq | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  getByID(id: string): Observable<Faq | undefined> {
    return this._api.getByID(id)
  }

  getFilteredList(q: Query<FaqQuery>): Observable<ItemList<Faq>> {
    return this._api.getFilteredList(q)
  }

  update(e: FaqDTO): Observable<Faq | undefined> {
    return this._api.update(e)
  }
}
